import FeaturedProductCarousel from "@/components/FeaturedProductCarousel.vue";
import * as themeColors from "@assets/styles/colors.module.scss";
import { builderCta } from "@/helpers/builder-init/index";
import { strippedCta } from "@/helpers/builder-init/index";
import { useBuilderShowIf } from "../composables/builderFieldUtility";
const colors = ["None", ...Object.keys(themeColors)];
const { hasValue, hasValueEqualTo, hasRichText } = useBuilderShowIf();
export const featuredProductCarouselInit = {
    component: FeaturedProductCarousel,
    name: "FeaturedProductCarousel",
    inputs: [
        // Banner
        {
            name: "banner_media",
            friendlyName: "Banner Media",
            type: "object",
            folded: false,
            defaultValue: {
                alt_text: "Hero Banner",
                bg_color: "None",
                max_height: 400,
                inset_banner: false,
                aria_label: "Hero Banner"
            },
            subFields: [
                // desktop media
                {
                    name: "desktop_media",
                    friendlyName: "Media for Desktop",
                    helperText:
                        "Will be used for mobile when no mobile media is given. Allowed file types - .jpeg, .png, .mp4, .gif, .svg",
                    allowedFileTypes: ["jpeg", "png", "mp4", "gif", "svg"],
                    type: "file"
                },
                // mobile img
                {
                    name: "mobile_media",
                    friendlyName: "Media for Mobile",
                    helperText:
                        "Allowed file types - .jpeg, .png, .mp4, .gif, .svg",
                    allowedFileTypes: ["jpeg", "png", "mp4", "gif", "svg"],
                    type: "file"
                },
                // alt text
                {
                    name: "alt_text",
                    friendlyName: "Alt Text",
                    type: "string",
                    showIf: hasValue("desktop_media"),
                    required: true
                },
                // gradient color
                {
                    name: "gradient_color",
                    friendlyName: "Gradient Color",
                    helperText: "",
                    type: "string",
                    enum: ['Default', ...colors.slice(1)]
                },
                // min height (px)
                {
                    name: "min_height",
                    friendlyName: "Min Banner Height (px)",
                    helperText: "",
                    type: "number"
                },
                // max height (px)
                {
                    name: "max_height",
                    friendlyName: "Max Banner Height (px)",
                    helperText: "",
                    type: "number"
                },
                // aria label
                {
                    name: "aria_label",
                    friendlyName: "Aria Label",
                    type: "string"
                }
            ]
        },
        {
            name: "eyebrow",
            friendlyName: "Eyebrow",
            type: "object",
            folded: false,
            defaultValue: {
                color: "None"
            },
            subFields: [
                // text
                {
                    name: "text",
                    friendlyName: "Text",
                    type: "string"
                },
                // color
                {
                    name: "color",
                    friendlyName: "Color",
                    type: "string",
                    enum: colors,
                    showIf: hasValue("text")
                }
            ]
        },
        // Heading
        {
            name: "heading",
            friendlyName: "Heading",
            type: "object",
            folded: false,
            defaultValue: {
                color: "None"
            },
            subFields: [
                // text
                {
                    name: "text",
                    friendlyName: "Text",
                    type: "richText"
                },
                // color
                {
                    name: "color",
                    friendlyName: "Color",
                    type: "string",
                    enum: colors,
                    showIf: hasRichText("text")
                }
                // // font_size_mobile
                // {
                //     name: "font_size_mobile",
                //     friendlyName: "Font Size (Mobile)",
                //     type: "number",
                //     showIf: hasRichText('text')
                // },
                // // font_size_desktop
                // {
                //     name: "font_size_desktop",
                //     friendlyName: "Font Size (Desktop)",
                //     type: "number",
                //     showIf: hasRichText('text')
                // },
            ]
        },

        // Carousel Controls
        {
            name: "tag",
            type: "string",
            defaultValue: "",
            friendlyName: "Merchandising Tag",
            onChange: (options) => {  
                if (options.get("tag")) {
                    options.set("isNew", false);
                }
            }
        },
        {
            name: "isNew",
            friendlyName: "New Arrivals",
            type: "boolean",
            defaultValue: false,
            onChange: (options) => {
                if (options.get("isNew")) {
                    options.set("tag", null);
                }
            }
        },
        {
            name: "allowQuickView",
            friendlyName: "Allow Quick View",
            helperText: "Toggle to allow the 'Quick Shop' button to show on the product cards when hovered.",
            type: "boolean",
            defaultValue: true
        },
        {
            name: 'cta',
            type: 'object',
            subFields: strippedCta(['aria_label', 'style', 'label']).subFields
        },
        {
            name: "autoplay",
            friendlyName: "Autoplay (ms)",
            helperText: "Minimum 1 second (1000ms).",
            type: "number",
            defaultValue: 0
        },
    ]
};
